import contract from './systemAlerts.contract.json';

export const SYSTEM_ALERT_CHANNEL_KEYS = Object.freeze(contract.channels);
export const SYSTEM_ALERT_EVENTS = Object.freeze(contract.events);
export const SYSTEM_ALERT_ADMIN_ROUTES = Object.freeze(contract.admin_routes);

export const systemAlertChannel = channel => contract.channel_names.channel.replace('{channel}', channel);
export const systemAlertUserChannel = id => contract.channel_names.user.replace('{id}', id);
export const systemAlertGroupChannel = id => contract.channel_names.group.replace('{id}', id);
export const systemAlertRoleChannel = slug => contract.channel_names.role.replace('{slug}', slug);
export const systemAlertCourseChannel = id => contract.channel_names.course.replace('{id}', id);
